import { toGreeklish, removeStopWords } from 'greek-utils';

// Function to count the number of words in a string
function countWords(str) {
    const REGEX = /[\w'-]+|[\u0370-\u03FF']+/gi;
    const wordsArray = str.match(REGEX) || [];
    const filteredWordsArray = wordsArray.filter(word => word.trim() !== '');
    return filteredWordsArray.length;
}

// Function to get unique words from a string
function getUniqueWords(str) {
    // Remove punctuation marks using a regular expression
    const cleanStr = str.replace(/[^\w\s]/g, ''); // Removes all non-word characters except spaces

    // Split the cleaned string into an array of words
    const wordsArray = cleanStr.split(/\s+/);

    // Use a Set to automatically remove duplicates
    const uniqueWords = new Set(wordsArray);
    
    return uniqueWords;
}

// Function to count common words between two sets
function countCommonWords(set1, set2) {
    let commonWordsCount = 0;
    set2.forEach(word => {
        if (set1.has(word)) {
            commonWordsCount++;
        }
    });
    return commonWordsCount;
}

const CommonWords = ({st1, st2}) => {
    let check = false;
    let perc = 0;
    
    st1 = removeStopWords(st1);
    st2 = removeStopWords(st2);
    st1 = toGreeklish(st1);
    st2 = toGreeklish(st2);
    
    
    const set1 = getUniqueWords(st1);
    const set2 = getUniqueWords(st2);
    
    console.log('unique1:',set1, 'unique2:', set2);

    const commonWordsCount = countCommonWords(set1, set2);
    
    st1=[...set1].join(' ');
    perc = commonWordsCount / countWords(st1);
    

    if (perc >= 0.10) {
        check = true;
    }

    const retArr = [check, perc];
    console.log(retArr);
    return retArr;
}

export default CommonWords; 
